module.exports = __webpack_public_path__ + "static/media/workout-login-page.499b225c.png";